import React from 'react';
import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { useRecoilState } from 'recoil';
import { landingZoneData } from 'pages/app-profiles/store';
import { CssTextField } from 'components/select';

const SourceResource = ({ index }) => {
    const [landingZoneForm] = useRecoilState(landingZoneData);
    const [ShrinkField, setShrinkField] = React.useState(true);

    return (
        <>
            <Stack direction="row" alignItems="center" justifyContent="center">
                <CssTextField
                    size="small"
                    label="Source Resource"
                    value={landingZoneForm?.connections?.[index]?.sourceComponentName}
                    InputLabelProps={{ shrink: ShrinkField }}
                    onClick={() => setShrinkField(true)}
                    autoComplete="off"
                    disabled
                />
            </Stack>
        </>
    );
};

SourceResource.propTypes = {
    index: PropTypes.number,
};

SourceResource.defaultProps = {
    index: 0,
};

export default React.memo(SourceResource);
